export default "__VITE_ASSET__foTNiPVL__"